import React, { useCallback } from "react";

// Libraries
import { Grid } from "@libraries/mui";

// Languages
import { SettingMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";

import * as Styled from "./styles";

export type IEnvironmentControllerTabs = "params" | "colors" | "icons";

interface Props {
  environmentControllerTabs: IEnvironmentControllerTabs;
  setEnvironmentControllerTabs: React.Dispatch<
    React.SetStateAction<IEnvironmentControllerTabs>
  >;
}

const EnvironmentTabButtons: React.FC<Props> = ({
  environmentControllerTabs,
  setEnvironmentControllerTabs
}) => {
  const { t } = useTranslation();

  const handleClick = useCallback(
    (controller: IEnvironmentControllerTabs) => {
      setEnvironmentControllerTabs(controller);
    },
    [setEnvironmentControllerTabs]
  );

  return (
    <Styled.Container>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Styled.EnvironmentButton
            active={environmentControllerTabs === "params"}
            onClick={() => handleClick("params")}
          >
            {t(SettingMessages.settingParamsTitle)}
          </Styled.EnvironmentButton>
        </Grid>
        <Grid item xs={4}>
          <Styled.EnvironmentButton
            active={environmentControllerTabs === "colors"}
            onClick={() => handleClick("colors")}
          >
            {t(SettingMessages.settingColorsTitle)}
          </Styled.EnvironmentButton>
        </Grid>
        <Grid item xs={4}>
          <Styled.EnvironmentButton
            active={environmentControllerTabs === "icons"}
            onClick={() => handleClick("icons")}
          >
            {t(SettingMessages.settingIconsTitle)}
          </Styled.EnvironmentButton>
        </Grid>
      </Grid>
    </Styled.Container>
  );
};

export default EnvironmentTabButtons;
